
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 192 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M96 512a80 80 0 1180-80 80.09 80.09 0 01-80 80z","opacity":".4"}}),_c('path',{attrs:{"fill":"currentColor","d":"M49.22 0h93.56a24 24 0 0124 25.2l-13.63 272a24 24 0 01-24 22.8H62.84a24 24 0 01-24-22.8l-13.59-272A24 24 0 0149.22 0z"}})])
          )
        }
      }
    